export const SELECT_EVENTS = {
  SEARCH: "search",
  ADD_ITEM: "addItem",
  GET_DATA: "getData",
  LOAD_MORE: "loadMore",
  EMITTERS: {
    FETCH_DATA: "fetchData"
  }
};

export const DYNAMIC_SELECT_EVENTS = {
  CHANGE: "onChange",
  CREATE: "onCreate",
  LOAD: "onLoad",
  UPDATE_DYNAMIC: "update:dynamicSelectList",
  ADD_ELEMENT: "addElement"
};

export const DYNAMIC_SELECT_TEXT = {
  NOT_FOUND: "No se encontraron resultados",
  MIN_CHARACTERS: "Ingrese al menos 3 caracteres"
};

export const NAME_CLASS = {
  LISTHEADER: "ListHeader"
};

export const DYNAMIC_SELECT_REF = "dinamycSelect";
